import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidBuildUpMethod from "../../../../service/visibleValidator/isValidBuildUpMethod"

import _4L_none from "./01_4L_none.png"
import _4L_1_2_1_withoutBH from "./02_4L_1-2-1_withoutBH.png"
import _4L_1_2_1_withBH_staggered from "./03_4L_1-2-1_withBH_staggered.png"
import _4L_1_2_1_withBH_stack from "./04_4L_1-2-1_withBH_stack.png"
import _4L_other from "./05_4L_other.png"
import _6L_none from "./11_6L_none.png"
import _6L_1_4_1_withoutBH from "./12_6L_1-4-1_withoutBH.png"
import _6L_1_4_1_withBH from "./13_6L_1-4-1_withBH.png"
import _6L_2_2_2_withoutBH from "./14_6L_2-2-2_withoutBH.png"
import _6L_2_2_2_stack from "./15_6L_2-2-2_stack.png"
import _6L_2_2_2_withBH_staggered from "./16_6L_2-2-2_withBH_staggered.png"
import _6L_2_2_2_withBH_fullstack from "./17_6L_2-2-2_withBH_fullstack.png"
import _6L_other from "./18_6L_other.png"
import _8L_none from "./21_8L_none.png"
import _8L_1_6_1_withoutBH from "./22_8L_1-6-1_withoutBH.png"
import _8L_2_4_2_withoutBH from "./23_8L_2-4-2_withoutBH.png"
import _8L_2_4_2_withoutBH_stack from "./24_8L_2-4-2_withoutBH_stack.png"
import _8L_2_4_2_withBH_staggered from "./25_8L_2-4-2_withBH_staggered.png"
import _8L_2_4_2_withBH_fullstack from "./26_8L_2-4-2_withBH_fullstack.png"
import _8L_3_2_3_withoutBH_staggered from "./27_8L_3-2-3_withoutBH_staggered.png"
import _8L_3_2_3_withoutBH_stack from "./28_8L_3-2-3_withoutBH_stack.png"
import _8L_3_2_3_withBH_fullstack from "./29_8L_3-2-3_withBH_fullstack.png"
import _8L_other from "./30_8L_other.png"
import _10L_none from "./31_10L_none.png"
import _10L_1_8_1 from "./32_10L_1-8-1.png"
import _10L_2_6_2 from "./33_10L_2-6-2.png"
import _10L_3_4_3 from "./34_10L_3-4-3.png"
import _10L_other from "./35_10L_other.png"
import _12L_none from "./41_12L_none.png"
import _12L_1_10_1 from "./42_12L_1-10-1.png"
import _12L_2_8_2 from "./43_12L_2-8-2.png"
import _12L_3_6_3 from "./44_12L_3-6-3.png"
import _12L_4_4_4 from "./45_12L_4-4-4.png"
import _12L_other from "./46_12L_other.png"

const ビルドアップ工法 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { buildUpMethod: shouldShow } = getDisplayCondition(values)

  const src = buildUpImageSrc[values.buildUpMethod]

  return (
    <OneClickField isShow={shouldShow} legend="ビルドアップ工法" helpURL={HELP_LINKS.ビルドアップ工法}>
      <Image src={src} alt="" />
      <Spacer size={12} />
      <RadioGroup
        name={FIELD_NAMES.ビルドアップ工法}
        selectedValue={values.buildUpMethod}
        onChange={handlers.radio}
        shouldRender={(value) => isValidBuildUpMethod(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["なし(4層)"].value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHなし"].value}>1-2-1{"\n"}BHなし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタガード"].value}>
            1-2-1{"\n"}BHあり スタガード
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタック"].value}>
            1-2-1{"\n"}BHあり スタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value}>その他の構成</Radio>

          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["なし(6層)"].value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHなし"].value}>1-4-1{"\n"}BHなし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHあり"].value}>1-4-1{"\n"}BHあり</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHなし"].value}>2-2-2{"\n"}BHなし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 スタック"].value}>2-2-2{"\n"}スタック</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり スタガード"].value}>
            2-2-2{"\n"}BHあり スタガード
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり フルスタック"].value}>
            2-2-2{"\n"}BHあり フルスタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value}>その他の構成</Radio>

          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["なし(8層)"].value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-6-1 BHなし"].value}>1-6-1{"\n"}BHなし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし"].value}>2-4-2{"\n"}BHなし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし スタック"].value}>
            2-4-2{"\n"}BHなし スタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり スタガード"].value}>
            2-4-2{"\n"}BHあり スタガード
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり フルスタック"].value}>
            2-4-2{"\n"}BHあり フルスタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタガード"].value}>
            3-2-3{"\n"}BHなし スタガード
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタック"].value}>
            3-2-3{"\n"}BHなし スタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHあり フルスタック"].value}>
            3-2-3{"\n"}BHあり フルスタック
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value}>その他の構成</Radio>

          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["なし(10層)"].value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-8-1"].value}>1-8-1</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-6-2"].value}>2-6-2</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["3-4-3"].value}>3-4-3</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value}>その他の構成</Radio>

          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["なし(12層)"].value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["1-10-1"].value}>1-10-1</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["2-8-2"].value}>2-8-2</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["3-6-3"].value}>3-6-3</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["4-4-4"].value}>4-4-4</Radio>
          <Radio value={ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value}>その他の構成</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.buildUpMethod} />
    </OneClickField>
  )
}

const buildUpImageSrc = {
  [ESTIMATE_CONSTANT.ビルドアップ工法["なし(4層)"].value]: _4L_none,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHなし"].value]: _4L_1_2_1_withoutBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタガード"].value]: _4L_1_2_1_withBH_staggered,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタック"].value]: _4L_1_2_1_withBH_stack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value]: _4L_other,
  [ESTIMATE_CONSTANT.ビルドアップ工法["なし(6層)"].value]: _6L_none,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHなし"].value]: _6L_1_4_1_withoutBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHあり"].value]: _6L_1_4_1_withBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHなし"].value]: _6L_2_2_2_withoutBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 スタック"].value]: _6L_2_2_2_stack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり スタガード"].value]: _6L_2_2_2_withBH_staggered,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり フルスタック"].value]: _6L_2_2_2_withBH_fullstack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value]: _6L_other,
  [ESTIMATE_CONSTANT.ビルドアップ工法["なし(8層)"].value]: _8L_none,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-6-1 BHなし"].value]: _8L_1_6_1_withoutBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし"].value]: _8L_2_4_2_withoutBH,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし スタック"].value]: _8L_2_4_2_withoutBH_stack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり スタガード"].value]: _8L_2_4_2_withBH_staggered,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり フルスタック"].value]: _8L_2_4_2_withBH_fullstack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタガード"].value]: _8L_3_2_3_withoutBH_staggered,
  [ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタック"].value]: _8L_3_2_3_withoutBH_stack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHあり フルスタック"].value]: _8L_3_2_3_withBH_fullstack,
  [ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value]: _8L_other,
  [ESTIMATE_CONSTANT.ビルドアップ工法["なし(10層)"].value]: _10L_none,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-8-1"].value]: _10L_1_8_1,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-6-2"].value]: _10L_2_6_2,
  [ESTIMATE_CONSTANT.ビルドアップ工法["3-4-3"].value]: _10L_3_4_3,
  [ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value]: _10L_other,
  [ESTIMATE_CONSTANT.ビルドアップ工法["なし(12層)"].value]: _12L_none,
  [ESTIMATE_CONSTANT.ビルドアップ工法["1-10-1"].value]: _12L_1_10_1,
  [ESTIMATE_CONSTANT.ビルドアップ工法["2-8-2"].value]: _12L_2_8_2,
  [ESTIMATE_CONSTANT.ビルドアップ工法["3-6-3"].value]: _12L_3_6_3,
  [ESTIMATE_CONSTANT.ビルドアップ工法["4-4-4"].value]: _12L_4_4_4,
  [ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value]: _12L_other,
} as { [key: string]: string }

export default ビルドアップ工法
